import React, { Component } from 'react';
import './scss/App.scss';
import $ from "jquery";

import iconWhite from "./img/connection-icon-wh.png";
import trigger from "./img/connection-icon.png";
import extremeCloud from './img/ExtremeCloud-Logo_RGB.png';
import extremeAnalytics from './img/ExtremeAnalytics-RGB.png';
import extremeGuest from './img/ExtremeGuest-RGB.png';
import extremeWireless from './img/ExtremeWireless-WiNG-Logo_RGB.png';
import extremeLocation from './img/ExtremeLocation-RGB.png';
import extremeAD from './img/ExtremeWireless-AirDefense-Logo_RGB.png';
import extremeControl from './img/ExtremeControl-RGB.png'

class App extends Component {

  constructor(props) {
    super(props);
  
    this.state = {
      header: "The Connected Retail Store",
      subHeader: "How purpose-built IT solutions can provide a personalized in-store experience for customers while alsostreamlining and enabling the critical operational assets of the business.",
      buttonText: "Learn More",
      currentContent: "0",
      resourceCenter: "Solution Resource Center",

     CARDS: [

      {
      cardHeader: "Keep Them Connected",
      cardContent: "Over 60% of retail stores plan to offer guest Wi-Fi by 2018, and over 77% of U.S. shoppers use their phone in-store to help them shop.  Learn more about delivering seamless, reliable connectivity to your guests.",
      link: "https://www.extremenetworks.com/extremewireless-wing/",
      logo: [
        {source: extremeWireless, URL: "https://www.extremenetworks.com/extremewireless-wing/", classes: "product-logo product-logo01"},
        {source: extremeGuest, URL: "https://www.extremenetworks.com/product/extremeguest/", classes: "product-logo product-logo02"}
        ]
      },

      {
      cardHeader: "Take Control of your Network",
      cardContent: " Gain centralized control and visibility across the network with powerful software, designed to scale efficiently from the smallest networks to the largest geographically dispersed deployments.",
      link: "https://www.extremenetworks.com/wing-software/",
      logo: [
        {source: extremeAD, URL: "https://www.extremenetworks.com/product/extreme-airdefense/", classes: "product-logo product-logo11"},
        {source: extremeGuest, URL: "https://www.extremenetworks.com/product/extremeguest/", classes: "product-logo product-logo12"}
        ]
      },

      {
      cardHeader: "Gain Valuable Insights and Analytics",
      cardContent: "The network is a business asset: take full advantage of the network with granular network actionable insights with comprehensive Wi-Fi analytics.",
      link: "https://content.extremenetworks.com/on-demand-webinars/improving-the-retail-experience",
      logo: [
        {source: extremeAnalytics, URL: "https://www.extremenetworks.com/product/extremeanalytics/", classes: "product-logo product-logo21"},
        {source: extremeControl, URL: "https://www.extremenetworks.com/product/extremecontrol/", classes: "product-logo product-logo22"}
      ]
      
      },

      {
      cardHeader: "Compete with the Online Giants",
      cardContent: "90% of retail sales still occur in-store, but in order for brick and mortar retailers to compete with rapidly rising digital giants, businesses must invest in key technologies to establish a more engaging and streamlined experience for guests.",
      link: "https://content.extremenetworks.com/extreme-networks-blog/fighting-digital-giants-the-importance-of-wi-fi-analytics-for-physical-retail-stores",
      logo: [
        {source: extremeAnalytics, URL: "https://www.extremenetworks.com/product/extremeanalytics/", classes: "product-logo product-logo31"},
        {source: extremeGuest, URL: "https://www.extremenetworks.com/product/extremeguest/", classes: "product-logo product-logo32"}
        ]
      },

      {
      cardHeader: "Provide a Personalized Experience",
      cardContent: "Retail stores must prioritize their efforts around gaining actionable insights from new consumers to deliver personalized experiences to their guests.",
      link: "https://www.extremenetworks.com/product/extremelocation/",
      logo: [
        {source: extremeLocation, URL: "https://www.extremenetworks.com/product/extremelocation/", classes: "product-logo product-logo41"},
        {source: extremeWireless, URL: "https://www.extremenetworks.com/extremewireless-wing/", classes: "product-logo product-logo42"}
        ]
      },

      {
      cardHeader: "Location, Location, Location!",
      cardContent: "Location, Location, Location! 80% of millennials today use their phones in-store while shopping, and 75% claim to be willing to receive location-based mobile alerts or promotions.",
      link: "https://content.extremenetworks.com/retail/extremewireless-locationing-a-new-lookg-at-location-based-solutions",
      logo: [
        {source: extremeLocation, URL: "https://www.extremenetworks.com/product/extremelocation/", classes: "product-logo product-logo51"},
        {source: extremeCloud, URL: "https://www.extremenetworks.com/extremecloud/", classes: "product-logo product-logo52"}
        ]
      },
      {
      cardHeader: "Flexible Network Solutions",
      cardContent: "Network infrastructure should be simple, secure, smart.  Support all the unique needs of the business with economical, flexible, and easy-to-manage hardware.",
      link: "https://www.extremenetworks.com/product/200-series/",
      logo: [
        {source: extremeWireless, URL: "https://www.extremenetworks.com/extremewireless-wing/", classes: "product-logo product-logo61"},
        {source: extremeLocation, URL: "https://www.extremenetworks.com/product/extremelocation/", classes: "product-logo product-logo62"}
        ]
      }

      ]

      
    };
  }

  addActive = (e) => {
    
    $(".details-wrap").addClass("active");
    let clicked = e.target;
    let i = $(clicked).data("card");
    console.log(i);
    this.setState({currentContent: i});
    document.querySelector('#mainContent').scrollIntoView({ 
      behavior: 'smooth' 
    }); 

  }
  toggleClose = () => {
    $(".details-wrap").removeClass("active");
  }
  closeActive = (event) => {
    if(!$(event.target).closest('.details-wrap').length) {
      if($('.details-wrap').is(":visible")) {
        $('.details-wrap').removeClass("active");
      }
    }        
  }

  

  render() {

    let cc = this.state.currentContent;
    let images = this.state.CARDS[cc].logo;
    
    let imageTags = images.map(function(item,i) {
      return <a href={item.URL} target="_blank" className="product-link" key={i}><img src={item.source} className={item.classes}/></a>
    });

    return (
      <div className="container App">

       

        <div className="row main" id="mainContent">
          <img src={trigger} alt="trigger" className="trigger-purple trigger-1" onClick={this.addActive} data-card="0" />
          <img src={trigger} alt="trigger" className="trigger-purple trigger-2" onClick={this.addActive} data-card="1" />
          <img src={trigger} alt="trigger" className="trigger-purple trigger-3" onClick={this.addActive} data-card="2" />
          <img src={trigger} alt="trigger" className="trigger-purple trigger-4" onClick={this.addActive} data-card="3" />
          <img src={trigger} alt="trigger" className="trigger-purple trigger-5" onClick={this.addActive} data-card="4" />
          <img src={trigger} alt="trigger" className="trigger-purple trigger-6" onClick={this.addActive} data-card="5" />
          <img src={trigger} alt="trigger" className="trigger-purple trigger-7" onClick={this.addActive} data-card="6" />

          <div className="col">
            <div className="row details-wrap">
              <div className="col details">
                <div className="row details-header">
                  <div className="col-3">
                    <img src={iconWhite} className="icon" alt="icon-white" />
                  </div>
                  <div className="col-9">
                    <h2>{this.state.CARDS[cc].cardHeader}</h2>
                    <i className="fa fa-times-circle close-icon" aria-hidden="true" onClick={this.toggleClose}></i>
                  </div>
                </div>
                <div className="row card-details">
                  <div className="col">
                    <p>{this.state.CARDS[cc].cardContent}</p>
                    <a href={this.state.CARDS[cc].link} target="_blank">
                      <button className="learn-more">
                        {this.state.buttonText}
                      </button>
                    </a>
                    <h3 className="resource-center">{this.state.resourceCenter}</h3>
                    <div className="product-logos">
                    {imageTags}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js